/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const bookingFrontdeskServiceSettings = sqliteTable('booking_frontdesk_service_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  service_id: text('service_id'),
  enabled: integer('enabled'),
  duration_override_mins: integer('duration_override_mins'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
